(() => {
  if (window.HBCollectionReturn) {
    window.HBCollectionReturn.refresh();
    return;
  }
  const key = 'hb-category-return-v1';
  function read() {
    try { return JSON.parse(sessionStorage.getItem(key) || '{}'); }
    catch (_) { return {}; }
  }
  function refresh() {
    document.querySelectorAll('[data-hb-collection-back]').forEach(link => {
      const banner = link.closest('[data-hb-collection-handle]');
      if (!banner) return;
      const previous = read()[banner.dataset.hbCollectionHandle];
      if (!previous) return;
      let choices;
      try { choices = JSON.parse(banner.dataset.hbParentChoices || '[]'); }
      catch (_) { return; }
      const choice = choices.find(item =>
        previous.path.endsWith(item.path) && previous.view === item.view);
      if (!choice) return;
      const target = new URL(previous.path, location.origin);
      if (target.origin !== location.origin) return;
      target.searchParams.set('view', choice.view);
      link.href = target.pathname + target.search;
      const label = link.querySelector('[data-hb-back-label]');
      if (label) label.textContent = banner.dataset.hbBackPattern.replace('__CATEGORY__', choice.label);
    });
  }
  function syncFooter() {
    refresh();
    const primary = document.querySelector('[data-hb-collection-back]');
    if (!primary) return;
    document.querySelectorAll('[data-hb-collection-footer-back]').forEach(link => {
      link.href = primary.getAttribute('href');
      const label = link.querySelector('[data-hb-back-label]');
      if (label) label.textContent = primary.querySelector('[data-hb-back-label]').textContent;
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || !link.closest('main')) return;
    const category = document.querySelector('[data-hb-category-page]');
    if (!category || !/\/pages\/[^/]+\/?$/.test(location.pathname)) return;
    let target;
    try { target = new URL(link.href, location.href); } catch (_) { return; }
    if (target.origin !== location.origin) return;
    const match = target.pathname.match(/\/collections\/([^/]+)\/?$/);
    if (!match) return;
    const previous = read();
    previous[decodeURIComponent(match[1])] = {
      path: location.pathname,
      view: new URL(location.href).searchParams.get('view') || category.dataset.hbCategoryView
    };
    try { sessionStorage.setItem(key, JSON.stringify(previous)); } catch (_) {}
  }, true);
  window.HBCollectionReturn = {refresh: syncFooter};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFooter, {once:true});
  else syncFooter();
  document.addEventListener('shopify:section:load', syncFooter);
  window.addEventListener('pageshow', syncFooter);
})();

